import { Admin, Resource, ListGuesser } from "react-admin";
import dataProvider from "./dataProvider";
import authProvider from "./authProvider"; // ✅ new
import { StoryList, StoryCreate, StoryShow } from "./stories";
import { EmotionList, EmotionCreate } from "./emotions";
import { MomentumList, MomentumCreate } from "./momentums";
import { FormationList, FormationCreate } from "./formations";
import { TimeCompressionList, TimeCompressionCreate } from "./timeCompressions";
import { DuckList, DuckCreate, DuckShow, DuckEdit } from "./ducks"; // ✅ new


export default function App() {
  return (
    <Admin dataProvider={dataProvider} authProvider={authProvider}>
      {/* ✅ UX resources */}
      <Resource name="quacks" list={ListGuesser} />
      <Resource name="duckid" list={ListGuesser} />
      <Resource name="meet_the_ducks" list={ListGuesser} />
      <Resource name="games" list={ListGuesser} />

      {/* ✅ Stories */}
      <Resource
        name="stories"
        list={StoryList}
        create={StoryCreate}
        show={StoryShow}
      />
      <Resource name="events" list={ListGuesser} />

      {/* 🦆 Ducks Section */}
      <Resource
        name="ducks"
        list={DuckList}
        create={DuckCreate}
        show={DuckShow}
        edit={DuckEdit}
        options={{ label: "Ducks" }}
      />

      {/* ✅ Back End Admin */}
      <Resource
        name="emotions"
        list={EmotionList}
        create={EmotionCreate}
        options={{ label: "Emotions" }}
      />
      <Resource
        name="momentums"
        list={MomentumList}
        create={MomentumCreate}
        options={{ label: "Momentums" }}
      />
      <Resource
        name="formations"
        list={FormationList}
        create={FormationCreate}
        options={{ label: "Formations" }}
      />
      <Resource
        name="time_compressions"
        list={TimeCompressionList}
        create={TimeCompressionCreate}
        options={{ label: "Time Compressions" }}
      />
    </Admin>
  );
}
